import GameCanvas from "./GameCanvas";

export default function JumpGame() {
	return <GameCanvas />;
}
